export default __webpack_public_path__ + "media/images/breakfast-eaa896622d7ad39f380c78f380e526cf.png";